import { TakeEffect, takeEvery } from 'redux-saga/effects';
import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { SkillCategory } from '@/swagger/constants/contents-orchestrator-enums';
import { API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_TAGS_PATH_KEY } from '@/swagger/constants/contents-orchestrator-keys';
import { KEY_GET_TAGS, API_GET_TAGS_CONTENTS } from '../constants';
import { MOCK_RESPONSE_GET_TAGS } from '../mocks';

type RequestGetTags = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_TAGS_PATH_KEY
>['request']['path'];

type ResponseGetTags = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_TAGS_PATH_KEY
>['response']['body'];

type CallParamsGetTags = Omit<RequestGetTags, 'organizationId'> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponseGetTags = ResponseGetTags;

type CallErrorGetTags = GenericApiError;

type CallSelectorsGetTags = {
  tags?: CallResponseGetTags;
};

export const getTagsCall = createGeneralCall<
  CallParamsGetTags,
  CallResponseGetTags,
  CallErrorGetTags,
  CallSelectorsGetTags
>({
  id: KEY_GET_TAGS,
  method: 'get',
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_GET_TAGS_CONTENTS(org as unknown as string, SkillCategory.SOFT_SKILL);
  },
  selectors: {
    tags: ({ selectors }) =>
      createSelector(selectors.response, tags => {
        if (!tags?.length) {
          return undefined;
        }
        return tags;
      }),
  },
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_TAGS : undefined,
  cancellable: true,
  takeEffect: takeEvery as unknown as TakeEffect,
  rsmOptions: {
    doubleRun: false,
  },
});
